import { SettingsIcon } from "@/components/Icons/SettingsIcon";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

type RecipeLogoProps = {
  logoUrl?: string;
  alt?: string;
  className?: string;
  fallbackClassName?: string;
};

export const RecipeLogo: React.FC<RecipeLogoProps> = ({
  logoUrl,
  alt = "",
  className,
  fallbackClassName
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [logoUrl]);

  if (!logoUrl || hasError) {
    return (
      <div
        className={cn(
          "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-dashed border-gray-dark-300 bg-muted/30 text-muted-foreground",
          fallbackClassName
        )}
        aria-hidden={!alt}
      >
        <SettingsIcon className="h-5 w-5" />
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={alt}
      loading="eager"
      decoding="async"
      referrerPolicy="no-referrer"
      className={cn(
        "h-10 w-10 shrink-0 rounded-lg border border-gray-dark-200/80 bg-background object-contain p-1",
        className
      )}
      onError={() => setHasError(true)}
    />
  );
};
